<div class="custom-searcher-wrapper">
    <input type="text" class="form-control" [placeholder]="placeholder" [(ngModel)]="inputText"
        (ngModelChange)="onInput($event)" (focus)="onFocus()" (blur)="onBlur()" [class.loading]="isLoading"
        [class.input-error]="hasError" [attr.aria-invalid]="hasError" autocomplete="off" role="combobox"
        [attr.aria-expanded]="showResults && !isLoading"
        [attr.aria-owns]="showResults && !isLoading ? 'search-dropdown-results' : null" />
    <button type="button" class="clear-btn" *ngIf="inputText && !isLoading"
        (click)="selectItem(null, true); inputText=''; onInput('')" tabindex="-1" aria-label="Clear selection">
        &times;
    </button>
    <div class="spinner-container" *ngIf="isLoading">
        <div class="button-spinner small" role="status" aria-label="Loading"></div>
    </div>

    <div class="custom-search-results" [class.results-hidden]="!showResults || isLoading" id="search-dropdown-results"
        role="listbox" [attr.aria-hidden]="!showResults || isLoading">
        <ul>
            <li *ngFor="let item of filteredItems; trackBy: trackByItem" (mousedown)="selectItem(item)"
                [class.selected]="valueField ? item[valueField] === lastCommittedValue : item === lastCommittedValue"
                role="option"
                [attr.aria-selected]="valueField ? item[valueField] === lastCommittedValue : item === lastCommittedValue">
                {{ getItemDisplay(item) }}
            </li>
            <li class="create-option" (mousedown)="handleCreateNew()"
                *ngIf="allowCreateNew && showCreateOption && inputText.trim() !== ''" role="option">
                {{ createNewTextFn(inputText) }}
            </li>
            <li class="no-results-message"
                *ngIf="filteredItems.length === 0 && (!allowCreateNew || !showCreateOption || inputText.trim() === '') && inputText.trim() !== ''"
                role="status">
                {{ 'dropdown.no_results' | translate }}
            </li>
            <li class="no-results-message"
                *ngIf="items.length === 0 && inputText.trim() === '' && minCharsForSearch === 0 && (!allowCreateNew || !showCreateOption || inputText.trim() === '')"
                role="status">
                {{ 'dropdown.no_items' | translate }}
            </li>
        </ul>
    </div>
</div>